@switch (kind) {
  @case ('owl') {
    <!-- An owl perched on an edge: its feet are on the bottom of the drawing. -->
    <svg class="tsd" viewBox="0 0 60 64" aria-hidden="true">
      <ellipse class="tsd-owl__wing" cx="13" cy="40" rx="6" ry="14" transform="rotate(12 13 40)"/>
      <ellipse class="tsd-owl__wing" cx="47" cy="40" rx="6" ry="14" transform="rotate(-12 47 40)"/>
      <path class="tsd-owl__body" d="M30,62 C14,62 10,50 10,38 C10,24 18,16 30,16 C42,16 50,24 50,38 C50,50 46,62 30,62 Z"/>
      <path class="tsd-owl__belly" d="M30,60 C21,60 19,52 19,45 C19,38 24,34 30,34 C36,34 41,38 41,45 C41,52 39,60 30,60 Z"/>
      <path class="tsd-owl__marks" d="M25,44 l2,2 2,-2 M31,44 l2,2 2,-2 M28,50 l2,2 2,-2"/>
      <g class="tsd-owl__face">
        <path class="tsd-owl__body" d="M14,22 L16,8 L25,18 Z M46,22 L44,8 L35,18 Z"/>
        <circle class="tsd-owl__eye" cx="23" cy="29" r="7"/>
        <circle class="tsd-owl__eye" cx="37" cy="29" r="7"/>
        <circle class="tsd-owl__pupil" cx="24" cy="29.5" r="3.2"/>
        <circle class="tsd-owl__pupil" cx="38" cy="29.5" r="3.2"/>
        <ellipse class="tsd-owl__lid" cx="23" cy="29" rx="7.4" ry="7.4"/>
        <ellipse class="tsd-owl__lid" cx="37" cy="29" rx="7.4" ry="7.4"/>
        <path class="tsd-owl__beak" d="M27.5,34 L32.5,34 L30,39 Z"/>
      </g>
      <path class="tsd-owl__feet" d="M24,60 v4 M27,60 v4 M33,60 v4 M36,60 v4"/>
    </svg>
  }
  @case ('fox') {
    <!-- A fox peeking over an edge; the drawing is clipped at the bottom, where the edge is. -->
    <svg class="tsd tsd--clip" viewBox="0 0 70 50" aria-hidden="true">
      <g class="tsd-fox">
        <g class="tsd-fox__ear tsd-fox__ear--left">
          <path class="tsd-fox__fur" d="M14,28 L17,4 L31,20 Z"/>
          <path class="tsd-fox__inner" d="M18,22 L19,11 L26,19 Z"/>
        </g>
        <g class="tsd-fox__ear tsd-fox__ear--right">
          <path class="tsd-fox__fur" d="M56,28 L53,4 L39,20 Z"/>
          <path class="tsd-fox__inner" d="M52,22 L51,11 L44,19 Z"/>
        </g>
        <path class="tsd-fox__fur" d="M8,56 C8,32 18,17 35,17 C52,17 62,32 62,56 Z"/>
        <path class="tsd-fox__cheek" d="M10,56 C14,44 26,40 35,46 C44,40 56,44 60,56 Z"/>
        <ellipse class="tsd-fox__eye" cx="25.5" cy="33" rx="2.4" ry="3"/>
        <ellipse class="tsd-fox__eye" cx="44.5" cy="33" rx="2.4" ry="3"/>
        <ellipse class="tsd-fox__nose" cx="35" cy="45" rx="3.2" ry="2.3"/>
      </g>
    </svg>
  }
  @case ('hoard') {
    <!-- A small dragon asleep on its coins -->
    <svg class="tsd" viewBox="0 0 120 72" aria-hidden="true">
      <path class="tsd-coins" d="M6,70 C12,56 30,48 54,48 C80,48 100,56 112,70 Z"/>
      <path class="tsd-coins__glint" d="M24,62 h9 M44,56 h8 M66,58 h9 M86,64 h8 M56,66 h7"/>
      <g class="tsd-dragon">
        <path class="tsd-dragon__tail" d="M40,52 C24,54 22,64 34,65 C46,66 54,62 64,64"/>
        <path class="tsd-dragon__body" d="M34,52 C34,36 50,28 66,30 C82,32 90,42 88,52 Z"/>
        <path class="tsd-dragon__spines" d="M44,36 l3,-6 3,5 M54,31 l3,-6 3,5 M64,30 l3,-6 3,5 M74,33 l3,-5 2,5"/>
        <path class="tsd-dragon__wing" d="M50,36 C52,22 64,18 72,24 C66,26 63,31 62,38 Z"/>
        <path class="tsd-dragon__belly" d="M42,50 C50,46 66,45 80,49"/>
        <ellipse class="tsd-dragon__body" cx="90" cy="48" rx="13" ry="8"/>
        <path class="tsd-dragon__horn" d="M84,42 L80,33 L89,40 Z"/>
        <path class="tsd-dragon__eye" d="M89,46 q3,2.4 6,0"/>
        <circle class="tsd-dragon__nostril" cx="100" cy="47" r="1"/>
      </g>
      <text class="tsd-z tsd-z--1" x="104" y="36">z</text>
      <text class="tsd-z tsd-z--2" x="110" y="26">z</text>
    </svg>
  }
  @case ('sprout') {
    <svg class="tsd" viewBox="0 0 72 64" aria-hidden="true">
      <path class="tsd-soil" d="M14,62 C20,52 52,52 58,62 Z"/>
      <path class="tsd-stem" d="M36,56 C36,46 35,38 37,30"/>
      <g class="tsd-leaf tsd-leaf--left"><path d="M36,40 C28,40 22,34 22,28 C30,28 36,32 36,40 Z"/></g>
      <g class="tsd-leaf tsd-leaf--right"><path d="M37,32 C42,24 50,22 56,24 C54,32 46,36 37,32 Z"/></g>
      <path class="tsd-sparkle" d="M50,8 l1.4,3.6 3.6,1.4 -3.6,1.4 -1.4,3.6 -1.4,-3.6 -3.6,-1.4 3.6,-1.4 Z"/>
    </svg>
  }
  @case ('island') {
    <svg class="tsd" viewBox="0 0 80 72" aria-hidden="true">
      <g class="tsd-island">
        <path class="tsd-island__rock" d="M12,34 H68 C64,46 52,58 40,66 C30,58 18,46 12,34 Z"/>
        <path class="tsd-island__grass" d="M10,34 C10,29 18,27 24,28 C30,25 50,25 56,28 C62,27 70,29 70,34 Z"/>
        <path class="tsd-island__trunk" d="M30,29 V22"/>
        <path class="tsd-island__tree" d="M30,4 C26,12 21,20 22,24 C23,27 37,27 38,24 C39,20 34,12 30,4 Z"/>
        <path class="tsd-island__fall" d="M60,36 C61,44 60,52 60,60"/>
      </g>
    </svg>
  }
  @case ('quill') {
    <svg class="tsd" viewBox="0 0 80 64" aria-hidden="true">
      <path class="tsd-scrap" d="M6,46 C24,42 50,44 74,40 L76,58 C52,62 26,60 8,62 Z"/>
      <path class="tsd-ink-line" pathLength="1" d="M14,53 C22,50 28,55 36,52 C42,50 46,54 52,51"/>
      <g class="tsd-quill">
        <path class="tsd-quill__vane" d="M54,50 C56,36 64,18 78,4 C80,16 74,30 64,40 C60,44 57,47 54,50 Z"/>
        <path class="tsd-quill__shaft" d="M52,53 C58,38 66,20 78,4"/>
      </g>
      <path class="tsd-sparkle tsd-sparkle--1" d="M38,30 l1,2.6 2.6,1 -2.6,1 -1,2.6 -1,-2.6 -2.6,-1 2.6,-1 Z"/>
      <path class="tsd-sparkle tsd-sparkle--2" d="M24,36 l.8,2 2,.8 -2,.8 -.8,2 -.8,-2 -2,-.8 2,-.8 Z"/>
    </svg>
  }
  @case ('bird') {
    <!-- A letter folded into a paper bird -->
    <svg class="tsd" viewBox="0 0 84 56" aria-hidden="true">
      <path class="tsd-trail" d="M4,46 C16,50 26,44 34,36"/>
      <g class="tsd-paper-bird">
        <path class="tsd-paper-bird__far" d="M46,26 L60,6 L58,28 Z"/>
        <path class="tsd-paper-bird__body" d="M34,34 L80,18 L54,34 L46,44 Z"/>
        <path class="tsd-paper-bird__near" d="M44,30 L52,4 L60,30 Z"/>
        <path class="tsd-paper-bird__fold" d="M54,34 L80,18"/>
      </g>
    </svg>
  }
}
